import { initBusinessCase } from '../components/businessCase';
import { initExpertsWhy } from '../components/expertsWhy';
import { initReviewsSlider } from '../components/reviews';
import { initWhatIs } from '../components/whatIs';

export function initExpertsPage() {
  initWhatIs();
  initReviewsSlider();
  initExpertsWhy();
  initBusinessCase();

  console.log('📄 Experts page initialized.');
}
